import { render, staticRenderFns } from "./TestDataUploadStatusModal.vue?vue&type=template&id=ad2242d8&scoped=true&"
import script from "./TestDataUploadStatusModal.vue?vue&type=script&lang=js&"
export * from "./TestDataUploadStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./TestDataUploadStatusModal.vue?vue&type=style&index=0&id=ad2242d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2242d8",
  null
  
)

export default component.exports